<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
      <div class="main-page-content">
        <el-row class="table-search">
          <el-form size="medium" :inline="true" :model="searchCondition" class="demo-form-inline">
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch"/>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <ApeTable
          ref="apeTable"
          style="font-size:12px;"
          :data="dataList"
          :columns="columns"
          :loading="loadingStaus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
          <el-table-column align="center" label="任务描述">
            <template slot-scope="scope">
              <div style="color:#1890ff;cursor: pointer;" v-if="scope.row.mission_content!=''" @click="showMissionContent(scope.row.mission_content)">查看</div>
              <div v-else>-</div>
            </template>
          </el-table-column>
			<el-table-column align="center" label="状态">
				<template slot-scope="scope">
					<div>{{ scope.row.status | TransactionStatus }}</div>
				</template>
			</el-table-column>
			<el-table-column align="center" label="审核状态">
				<template slot-scope="scope">
					<div>{{ scope.row.examine_status=="1"?"审核成功":scope.row.examine_status=="2"?"审核失败":"审核中"}}</div>
					<div style="color:#1890ff;cursor: pointer;" v-if="scope.row.examine_status=='2'" @click="showMissionContent(scope.row.examine_reason)">查看失败原因</div>
				</template>
			</el-table-column>
			<el-table-column align="center" label="合作邀请码">
				<template slot-scope="scope">
              <div style="color:#1890ff;cursor: pointer;" v-if="scope.row.examine_status=='1'&&scope.row.status=='1'&&scope.row.code_url" @click="showMissionCode(scope.row.code_url)">查看</div>
              <div v-else>-</div>
				</template>
			</el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <span>
                <el-popover placement="top" v-model="scope.row.visible" v-if="scope.row.examine_status=='1'">
                  <p>确定要修改状态吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button type="text" size="mini" @click="scope.row.visible=false">取消</el-button>
                    <el-button type="danger" size="mini"
                               @click="checkUpload(scope.row.status, scope.row.id)">确定</el-button>
                  </div>
                  <el-button
                    size="mini"
                    :type="scope.row.status == 1 ? 'danger' : 'primary'"
                    slot="reference"
                  >{{ scope.row.status == 1 ? '关闭' : '开启' }}</el-button>
                </el-popover>
				<el-button type="infor" size="mini" @click="toView(scope.row)">详情</el-button>
              </span>
            </template>
          </el-table-column>
        </ApeTable>
		
		<el-dialog
			width="40%"
			:title="'系统提示'"
			:close-on-click-modal="false"
			:visible.sync="innerVisible"
			:before-close="handleInnerClose"
			append-to-body
		>
			<div v-if="tabType==1">
				<div class="dialog-title">
					<i
						class="el-icon-success"
						style="font-size: 40px; color: #409eff"
					></i>
					<span class="title-text">手机扫一扫，请到手机端分享</span>
				</div>
				<div class="center-box">
					<img :src="this.OrImage" class="QR-code" v-if="this.OrImage"/>
				</div>
			</div>
			<div v-if="tabType==2">
				<div class="center-box">
					<el-input type="textarea" readonly rows="8" :value="tabContent"></el-input>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button
					type="primary"
					@click="closeQRDialog"
					size="medium">
				关闭
				</el-button>
			</div>
		</el-dialog>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import DatePicker from '@/components/DatePicker.vue'

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    DatePicker
  },
  data() {
    return {
		loadingStaus: false,
		// 搜索条件
		searchCondition: {},
		//任务列表
		dataList: [],
		// 分页信息
		pagingData: {
		is_show: true,
		layout: "total, sizes, prev, pager, next, jumper",
		total: 0,
		},
		columns: [
			{
				title: "编号",
				value: "id",
				header_align: "center",
				align: "center",
			},
			{
				title: "税源地名称",
				value: "channel_name",
				header_align: "center",
				align: "center",
			},
			{
				title: "服务类型",
				value: "category_name",
				header_align: "center",
			},
			{
				title: "提交时间",
				value: "created_at",
				header_align: "center",
				align: "center",
			},
		],
		visible: false,
		innerVisible:false,
		OrImage:"",
		tabContent:"",
		tabType:1
		
    };
  },
  computed: {},
  watch: {
    "$route.matched": function (n, o) {
      console.log(o)
      if (n.length === 2) {
        this.init()
      }
    },
    "visible": function (v) {
      console.log("visible", v)
    }
  },
  methods: {
    // 相应删除按钮
    async deleteButton(id) {
      let ids = this.$refs['treeTable'].getExpandIds()
      let info = await this.$api.deleteCategoryInfo(id)
      if (info == 'ok') {
        let {list} = await this.$api.getCategoryList()
        this.categoryList = list
        this.$nextTick(() => {
          this.$refs['treeTable'].initTableExpand(ids)
        })
        this.$message.success('删除成功!')
      } else {
        this.$message.error(info)
      }
    },
    async checkUpload(status, id) {
      var missionStatus;
      if (status == 1) {
        missionStatus = 0
      }
      if (status == 0) {
        missionStatus = 1
      }
      let args = {
        status: missionStatus,
        id
      }
      let res = await this.$api.getMissionSaveStatus(args)
      if (res) {
        this.init()
      }
    },
    changeStatus() {
      this.visible = true
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value
    },
    // 搜索
    searchButton() {
      this.init('search')
    },
    // 切换页码操作
    async switchPaging() {
      this.init()
    },
    // 初始化
    async init(type) {
      this.loadingStaus = false
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      if (type == 'export') {
        pagingInfo.page_size = 50000
      } else {
        this.loadingStaus = true
      }
      if (type == 'search') {
        pagingInfo.current_page = 1
      }
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition, pagingInfo)
      let {list, pages} = await this.$api.getMissionList(searchCondition)
      this.dataList = list
      if (type == 'export') {
        return list
      } else {
        this.dataList = list
        this.pagingData.total = pages.total
        this.offset = pages.offset
        this.loadingStaus = false
      }
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.outer_trade_no) {
        condition.outer_trade_no = this.searchCondition.outer_trade_no
      }
      if (this.searchCondition.name) {
        condition.name = this.searchCondition.name
      }
      if (this.searchCondition.time_value) {
        condition.time = {
          start_time: this.searchCondition.time_value[0],
          end_time: this.searchCondition.time_value[1],
        }
      }
      return condition
    },
	showMissionContent(content){
		this.tabType = 2;
		this.tabContent = content;
		this.innerVisible = true;
	},
	handleInnerClose(){
		this.innerVisible = false;
		this.OrImage = "";
	},
    //关闭二维码弹窗
    closeQRDialog() {
		this.innerVisible = false;
		this.OrImage = "";
    },
	// 开启二维码弹框
	showMissionCode(url){
		this.OrImage = url;
		this.tabType = 1;
		this.innerVisible = true;
	},
	// 跳转详情页面
	toView(row) {
		this.$router.push({name:"mission_center_view",params:row});
	}
  },
  created() {
  },
  mounted() {
	let nowCompany=localStorage.getItem('nowCompany')
	if(nowCompany){
	nowCompany=JSON.parse(nowCompany)
	}
	if(nowCompany.id==='443428954977423360'){
		this.columns.pop()
	}
	console.log('columns',nowCompany,this.columns)
    this.init()
  },
}
</script>

<style lang="stylus" scoped>
.el-button
  margin-right 4px
  margin-bottom 4px

.table-header
  margin-bottom 12px

.el-popover .el-checkbox-group .el-checkbox
  margin-left 0px
  margin-right 12px

.el-table
  font-size: 14px

.table-right
  float: right

.select-box
  width: 100px
  
.dialog-title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: -20px;
}

.title-text {
  font-size: 20px;
  margin-left: 10px;
}

.center-box {
  display: flex;
  justify-content: center;
  align-item: center;
  padding: 30px 0;
}

.QR-code {
  width: 150px;
  height: 150px;
}

.main-page-content {
  position: relative;
}

.select-box {
  width: 100px;
}
</style>
